import { render, staticRenderFns } from "./CaixaDeSelecao.vue?vue&type=template&id=3b45ae00"
import script from "./CaixaDeSelecao.vue?vue&type=script&lang=js"
export * from "./CaixaDeSelecao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports